(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ombrail-contact"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const MODES={quote:'Quote for a piece',standard:'Quote for a piece',custom:'Another size or stone',question:'Product question','room-preview':'Product question',room:'Product question',project:'Room or project',order:'Existing order'};
  function bind(){document.querySelectorAll('[data-o-contact]').forEach(root=>{
    if(root.dataset.quoteBound)return;root.dataset.quoteBound='true';
    const query=new URLSearchParams(location.search);
    const clean=(key,max=180)=>(query.get(key)||'').replace(/[\x00-\x1f]/g,' ').trim().slice(0,max);
    const hint=root.querySelector('[data-o-contact-hint]');
    const radios=[...root.querySelectorAll('input[name="contact[Request]"]')];
    const sync=()=>{const on=radios.find(r=>r.checked);if(on&&hint&&on.dataset.hint)hint.textContent=on.dataset.hint;};
    radios.forEach(r=>r.addEventListener('change',sync));
    const request=clean('request',40);
    const wanted=MODES[request];
    if(wanted){const r=radios.find(x=>x.value===wanted);if(r){r.checked=true;}}
    sync();
    const body=root.querySelector('textarea[name="contact[body]"]');
    const piece=clean('piece');
    const message=clean('message',500);
    if(!piece){if(body&&!body.value&&message)body.value=(request==='question'?'I am looking for: ':'')+message;return;}
    const title=clean('title')||piece.replace(/-/g,' ');const reference=clean('reference');
    const summary=root.querySelector('[data-o-contact-product]');summary.textContent=[title,reference].filter(Boolean).join(' · ');summary.hidden=false;
    if(body&&!body.value){
      const quantity=Number(clean('quantity'));
      const lines=request==='room-preview'||request==='room'
        ?['Please let me know when the room preview opens for: '+title,reference?'Reference: '+reference:'']
        :[(wanted==='Another size or stone'?'Custom request: ':wanted==='Product question'?'Question about: ':'Quotation request: ')+title,reference?'Reference: '+reference:'','Product: '+piece,quantity>0?'Quantity: '+Math.min(999,Math.floor(quantity)):'',clean('configuration')==='custom'?'Custom specification: '+clean('notes',500):'',message,'',wanted==='Product question'?'':'Please confirm the price, availability and delivery.'];
      body.value=lines.filter((line,index)=>line||index>5).join('\n').trim();
    }
  });}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind);else bind();
  document.addEventListener('shopify:section:load',bind);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ombrail-footer"]) return;
  try {
    
if (!customElements.get('ombrail-footer')) {
  customElements.define('ombrail-footer', class extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.mobileQuery = window.matchMedia('(max-width:760px)');
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      const hoverQuery = window.matchMedia('(hover:hover) and (pointer:fine)');
      const groups = [...this.querySelectorAll('[data-o-footer-group]')];
      const syncGroups = () => groups.forEach(group => {
        group.open = !this.mobileQuery.matches;
        group.querySelector('summary').tabIndex = this.mobileQuery.matches ? 0 : -1;
      });
      syncGroups();
      this.mobileQuery.addEventListener('change', syncGroups, options);
      groups.forEach(group => group.querySelector('summary').addEventListener('click', event => {
        if (!this.mobileQuery.matches) event.preventDefault();
      }, options));
      // The assistant is loaded with "defer": hide its entry points if it never starts on this page.
      window.addEventListener('load', () => {
        if (!window.OmbrailAI) this.querySelectorAll('[data-o-ask-general]').forEach(el => { el.hidden = true; });
      }, { once: true, signal: this.abortController.signal });
      // Newsletter: after a successful or failed post, bring the form back into view.
      const offer = this.querySelector('#FooterOffer');
      const offerStatus = this.querySelector('[data-o-offer-status]');
      // v24: a post from the newsletter pop-up (#OmbrailPopupNewsletter) is answered in the pop-up, not here.
      if (offer && offerStatus && !/OmbrailPopupNewsletter/.test(location.hash)) {
        requestAnimationFrame(() => {
          offer.scrollIntoView({ block: 'start' });
          offerStatus.focus({ preventScroll: true });
        });
      }
      const vouchers = this.querySelector('[data-o-vouchers]');
      if (vouchers && !this.motionQuery.matches && 'IntersectionObserver' in window) {
        vouchers.classList.add('is-armed');
        const vObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { vouchers.classList.add('is-seen'); vObserver.disconnect(); }
        }, { threshold: .35 });
        vObserver.observe(vouchers);
        this.abortController.signal.addEventListener('abort', () => vObserver.disconnect());
      } else if (vouchers) {
        vouchers.classList.add('is-seen');
      }
      this.querySelectorAll('[data-o-copy]').forEach(button => button.addEventListener('click', async () => {
        const code = button.dataset.oCopy;
        let done = false;
        try { await navigator.clipboard.writeText(code); done = true; } catch (e) {
          const range = document.createRange();
          const value = this.querySelector('.o-foot__code-value');
          if (value) { range.selectNodeContents(value); const sel = getSelection(); sel.removeAllRanges(); sel.addRange(range); done = document.execCommand && document.execCommand('copy'); }
        }
        if (done) {
          const label = button.textContent;
          button.textContent = button.dataset.labelDone || 'Copied';
          setTimeout(() => { button.textContent = label; }, 2200);
        }
      }, options));
      const controls = this.querySelector('.o-foot__folio-controls');
      if (controls) {
        controls.hidden = false;
        const buttons = [...controls.querySelectorAll('button')];
        const selectView = button => {
          this.dataset.view = button.dataset.oFooterView;
          buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        };
        buttons.forEach(button => {
          button.addEventListener('click', () => selectView(button), options);
          button.addEventListener('focus', () => selectView(button), options);
          button.addEventListener('pointerenter', () => {
            if (hoverQuery.matches && !this.motionQuery.matches) {
              clearTimeout(this.hoverTimer);
              this.hoverTimer = setTimeout(() => selectView(button), 100);
            }
          }, options);
          button.addEventListener('pointerleave', () => clearTimeout(this.hoverTimer), options);
        });
      }
      const reveal = () => {
        this.classList.add('is-revealed');
        this.revealObserver?.disconnect();
      };
      this.addEventListener('focusin', reveal, options);
      this.motionQuery.addEventListener('change', event => { if (event.matches) reveal(); }, options);
      if (!this.motionQuery.matches && 'IntersectionObserver' in window) {
        this.classList.add('is-enhanced');
        this.revealObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) reveal();
        }, { threshold: .12 });
        this.revealObserver.observe(this.querySelector('.o-foot__signature'));
      }
      this.querySelector('[data-o-footer-top]')?.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const header = document.querySelector('#ombrail-header');
        if (!header) return;
        event.preventDefault();
        header.querySelector('a[href]')?.focus({ preventScroll: true });
        window.scrollTo({ top: 0, behavior: this.motionQuery.matches ? 'instant' : 'smooth' });
      }, options);
    }
    disconnectedCallback() {
      clearTimeout(this.hoverTimer);
      this.revealObserver?.disconnect();
      this.abortController?.abort();
      this.abortController = null;
      this.classList.remove('is-enhanced');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ombrail-header"]) return;
  try {
    
/* v22 header: panels on hover, side menu with levels, pieces loaded on demand. */
if (!customElements.get('ombrail-header')) {
  customElements.define('ombrail-header', class extends HTMLElement {
    connectedCallback() {
      if (this.ac) return;
      this.ac = new AbortController();
      const o = { signal: this.ac.signal };
      this.desktop = window.matchMedia('(min-width:1101px)');
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.feeds = new Map();
      this.feedData = new Map();
      this.waiting = [];
      this.running = 0;
      this.setupMega(o);
      this.setupDialogs(o);
      this.setupDrawer(o);
      this.setupRails(this, o);
      this.setupBadges();
      this.setupNotice(o);
      this.setupScroll(o);
    }

    /* Pieces of a collection or tag page, from sections/ombrail-header-feed.liquid */
    feed(url, urgent) {
      if (!url) return Promise.resolve(null);
      if (this.feeds.has(url)) {
        if (urgent) {
          const index = this.waiting.findIndex(job => job.url === url);
          if (index > 0) this.waiting.unshift(...this.waiting.splice(index, 1));
        }
        return this.feeds.get(url);
      }
      const promise = new Promise(resolve => {
        const job = { url, resolve };
        if (urgent) this.waiting.unshift(job); else this.waiting.push(job);
      });
      this.feeds.set(url, promise);
      this.pump();
      return promise;
    }
    pump() {
      while (this.running < 3 && this.waiting.length) {
        const { url, resolve } = this.waiting.shift();
        this.running += 1;
        const address = url + (url.includes('?') ? '&' : '?') + 'section_id=ombrail-header-feed';
        fetch(address, { credentials: 'same-origin' })
          .then(response => (response.ok ? response.text() : Promise.reject(new Error(String(response.status)))))
          .then(html => {
            const node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-o-feed]');
            if (!node) { resolve(null); return; }
            const images = [...node.querySelectorAll('img')].map(item => item.getAttribute('src'));
            const data = { count: Number(node.dataset.count) || 0, html: node.innerHTML.trim(), image: images[0] || '', feature: node.dataset.feature || (images.length > 3 ? images[images.length - 1] : images[0] || '') };
            this.feedData.set(url, data);
            resolve(data);
            this.applyFeed(url, data);
          })
          .catch(() => { this.feeds.delete(url); resolve(null); })
          .finally(() => { this.running -= 1; this.pump(); });
      }
    }
    sized(src, width) {
      return src ? src.replace(/([?&]width=)\d+/, '$1' + width) : '';
    }
    applyFeed(url, data) {
      this.querySelectorAll('[data-o-url],[data-o-thumb]').forEach(element => {
        if ((element.dataset.oUrl || element.dataset.oThumb) !== url) return;
        const label = element.querySelector('[data-o-count-label]');
        if (label && !label.textContent.trim() && data.count) label.textContent = data.count;
        if (element.dataset.oUrl !== undefined && !element.dataset.oCount && data.count) element.dataset.oCount = data.count;
        const box = element.dataset.oThumb ? element.querySelector('.o-nav__m-thumb, .o-nav__family-thumb') : null;
        if (box && !box.querySelector('img') && data.image) {
          const image = new Image(112, 112);
          image.alt = '';
          image.decoding = 'async';
          image.src = this.sized(data.image, 200);
          box.append(image);
        }
      });
    }
    skeleton(count) {
      return Array.from({ length: count }, () => '<li class="o-nav__skel" aria-hidden="true"></li>').join('');
    }

    /* Desktop: families open on hover, click or keyboard */
    setupMega(o) {
      this.triggers = [...this.querySelectorAll('[data-o-trigger]')];
      this.panels = [...this.querySelectorAll('[data-o-panel]')];
      this.panelFor = trigger => this.panels.find(panel => panel.dataset.oPanel === trigger.dataset.oTrigger);
      this.triggers.forEach(trigger => {
        const panel = this.panelFor(trigger);
        trigger.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse' || !this.desktop.matches) return;
          clearTimeout(this.closeTimer);
          clearTimeout(this.openTimer);
          this.openTimer = setTimeout(() => this.openPanel(trigger, 'hover'), this.current ? 40 : 110);
          const first = panel?.querySelector('[data-o-cat]');
          if (first) this.feed(first.dataset.oUrl);
        }, o);
        trigger.addEventListener('pointerleave', event => {
          if (event.pointerType !== 'mouse') return;
          clearTimeout(this.openTimer);
          this.scheduleClose();
        }, o);
        trigger.addEventListener('click', () => {
          const open = trigger.getAttribute('aria-expanded') === 'true';
          if (open && this.openedBy === 'hover' && Date.now() - this.openedAt < 700) return;
          if (open) this.closePanel(false);
          else this.openPanel(trigger, 'click');
        }, o);
        trigger.addEventListener('keydown', event => {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            this.openPanel(trigger, 'key');
            panel?.querySelector('[data-o-cat]')?.focus();
          } else if (event.key === 'Tab' && !event.shiftKey && this.current === panel) {
            const first = this.focusables(panel)[0];
            if (first) { event.preventDefault(); first.focus(); }
          }
        }, o);
        trigger.addEventListener('focus', () => {
          if (this.current && this.current !== panel) this.closePanel(false);
        }, o);
      });
      this.querySelector('[data-o-list]')?.addEventListener('keydown', event => {
        if (!['ArrowRight', 'ArrowLeft'].includes(event.key)) return;
        const items = [...this.querySelectorAll('.o-nav__list > li > :is(a, button)')];
        const index = items.indexOf(document.activeElement);
        if (index < 0) return;
        event.preventDefault();
        items[(index + (event.key === 'ArrowRight' ? 1 : -1) + items.length) % items.length].focus();
      }, o);
      this.panels.forEach(panel => {
        panel.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const items = this.focusables(panel);
          const trigger = this.triggers.find(item => this.panelFor(item) === panel);
          if (event.shiftKey && document.activeElement === items[0]) { event.preventDefault(); trigger?.focus(); }
          else if (!event.shiftKey && document.activeElement === items[items.length - 1]) {
            const tops = [...this.querySelectorAll('.o-nav__list > li > :is(a, button)')];
            const next = tops[tops.indexOf(trigger) + 1];
            if (next) { event.preventDefault(); this.closePanel(false); next.focus(); }
          }
        }, o);
        panel.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') clearTimeout(this.closeTimer); }, o);
        panel.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') this.scheduleClose(); }, o);
        panel.querySelectorAll('[data-o-cat]').forEach(link => {
          link.addEventListener('pointerenter', event => {
            if (event.pointerType !== 'mouse') return;
            clearTimeout(this.catTimer);
            this.catTimer = setTimeout(() => this.showCategory(panel, link), 70);
          }, o);
          link.addEventListener('pointerleave', () => clearTimeout(this.catTimer), o);
          link.addEventListener('focus', () => this.showCategory(panel, link), o);
        });
        const image = panel.querySelector('[data-o-stage-img]');
        image?.addEventListener('load', () => image.classList.add('is-in'), o);
        image?.addEventListener('error', () => { image.hidden = true; image.closest('[data-o-stage]')?.classList.add('no-image'); }, o);
      });
      this.querySelector('[data-o-scrim]')?.addEventListener('click', () => this.closePanel(false), o);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.current) { event.preventDefault(); this.closePanel(true); }
      }, o);
      this.addEventListener('focusout', event => {
        if (this.current && event.relatedTarget && !this.contains(event.relatedTarget)) this.closePanel(false);
      }, o);
      document.addEventListener('pointerdown', event => {
        if (this.current && !this.contains(event.target)) this.closePanel(false);
      }, o);
      this.desktop.addEventListener('change', () => this.closePanel(false), o);
      window.addEventListener('resize', () => { if (this.current) this.fitPanel(); }, { passive: true, ...o });
    }
    focusables(root) {
      return [...root.querySelectorAll('a[href], button:not([disabled])')].filter(item => item.getClientRects().length && !item.closest('[inert]'));
    }
    fitPanel() {
      const bottom = this.querySelector('.o-nav__barwrap').getBoundingClientRect().bottom;
      this.style.setProperty('--o-panel-max', Math.max(260, window.innerHeight - bottom) + 'px');
    }
    openPanel(trigger, how) {
      const panel = this.panelFor(trigger);
      if (!panel || !this.desktop.matches) return;
      clearTimeout(this.closeTimer);
      if (this.current === panel) return;
      const switching = Boolean(this.current);
      this.panels.forEach(item => {
        const open = item === panel;
        item.classList.toggle('is-open', open);
        item.classList.toggle('is-switch', open && switching);
        item.inert = !open;
      });
      this.triggers.forEach(item => item.setAttribute('aria-expanded', String(item === trigger)));
      this.current = panel;
      this.currentTrigger = trigger;
      this.openedBy = how;
      this.openedAt = Date.now();
      this.classList.add('is-menu-open');
      this.fitPanel();
      const active = panel.querySelector('[data-o-cat].is-active') || panel.querySelector('[data-o-cat][aria-current]') || panel.querySelector('[data-o-cat]');
      if (active) this.showCategory(panel, active);
    }
    closePanel(returnFocus) {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      clearTimeout(this.catTimer);
      if (!this.current) return;
      const panel = this.current;
      const trigger = this.currentTrigger;
      const hadFocus = panel.contains(document.activeElement);
      panel.classList.remove('is-open', 'is-switch');
      panel.inert = true;
      trigger?.setAttribute('aria-expanded', 'false');
      this.current = null;
      this.currentTrigger = null;
      this.classList.remove('is-menu-open');
      if (returnFocus || hadFocus) trigger?.focus({ preventScroll: true });
    }
    scheduleClose() {
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => this.closePanel(false), 280);
    }
    showCategory(panel, link) {
      const stage = panel.querySelector('[data-o-stage]');
      if (!stage) return;
      const url = link.dataset.oUrl;
      panel.querySelectorAll('[data-o-cat]').forEach(item => item.classList.toggle('is-active', item === link));
      if (stage.dataset.url === url) return;
      stage.dataset.url = url;
      const title = link.dataset.oTitle || link.textContent.trim();
      stage.querySelector('[data-o-stage-link]').href = url;
      stage.querySelector('[data-o-stage-title]').textContent = title;
      const railTitle = stage.querySelector('[data-o-rail-title]');
      if (railTitle) railTitle.textContent = title.toLowerCase();
      this.setCount(stage, link.dataset.oCount);
      if (link.dataset.oImg) this.setStageImage(stage, link.dataset.oImg, false);
      else { const cached = this.feedData?.get(url); if (cached) this.setStageImage(stage, cached.feature ? this.sized(cached.feature, 900) : '', true); }
      stage.classList.remove('is-changing');
      void stage.offsetWidth;
      stage.classList.add('is-changing');
      const track = stage.querySelector('[data-o-track]');
      track.dataset.for = url;
      track.innerHTML = this.skeleton(4);
      track.scrollLeft = 0;
      this.updateRail(track);
      this.feed(url, true).then(data => {
        if (track.dataset.for !== url) return;
        if (data && data.html) track.innerHTML = data.html;
        else track.innerHTML = '<li class="o-nav__empty"><a href="' + url + '">See all ' + title.toLowerCase().replace(/[<>&"]/g, '') + '</a></li>';
        track.scrollLeft = 0;
        this.updateRail(track);
        if (stage.dataset.url !== url) return;
        if (data) this.setCount(stage, link.dataset.oCount || data.count);
        if (!link.dataset.oImg) this.setStageImage(stage, data && data.feature ? this.sized(data.feature, 900) : '', true);
      });
    }
    setCount(stage, count) {
      const node = stage.querySelector('[data-o-stage-count]');
      const value = Number(count) || 0;
      if (node) node.textContent = value ? 'Shop all ' + value + (value === 1 ? ' piece' : ' pieces') : 'Shop all';
    }
    setStageImage(stage, src, product) {
      const image = stage.querySelector('[data-o-stage-img]');
      if (!image) return;
      if (!src) {
        if (product === undefined) return;
        image.hidden = true;
        image.removeAttribute('src');
        stage.classList.remove('is-product');
        stage.classList.add('no-image');
        return;
      }
      stage.classList.remove('no-image');
      stage.classList.toggle('is-product', Boolean(product));
      if (image.getAttribute('src') === src) return;
      image.classList.remove('is-in');
      image.hidden = false;
      image.src = src;
      if (image.complete && image.naturalWidth) requestAnimationFrame(() => image.classList.add('is-in'));
    }

    /* Rows of pieces */
    setupRails(root, o) {
      root.querySelectorAll('[data-o-rail]').forEach(rail => {
        if (rail.dataset.bound) return;
        rail.dataset.bound = 'true';
        const track = rail.querySelector('[data-o-track]');
        rail.querySelector('[data-o-rail-prev]')?.addEventListener('click', () => this.scrollRail(track, -1), o);
        rail.querySelector('[data-o-rail-next]')?.addEventListener('click', () => this.scrollRail(track, 1), o);
        track?.addEventListener('scroll', () => this.updateRail(track), { passive: true, ...o });
      });
    }
    scrollRail(track, direction) {
      const card = track.querySelector('li');
      const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 16) : track.clientWidth * 0.8;
      track.scrollBy({ left: direction * step * 2, behavior: this.reduce.matches ? 'auto' : 'smooth' });
    }
    updateRail(track) {
      const rail = track?.closest('[data-o-rail]');
      if (!rail) return;
      const max = track.scrollWidth - track.clientWidth - 2;
      const prev = rail.querySelector('[data-o-rail-prev]');
      const next = rail.querySelector('[data-o-rail-next]');
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      rail.classList.toggle('is-static', max <= 0);
    }

    /* Search panel and side menu */
    setupDialogs(o) {
      this.dialogs = [...this.querySelectorAll('[data-o-dialog]')];
      this.openers = [...this.querySelectorAll('[data-o-open]')];
      this.openers.forEach(opener => opener.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const dialog = this.dialogs.find(item => item.dataset.oDialog === opener.dataset.oOpen);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        if (dialog.open) return;
        this.dialogs.forEach(item => { if (item.open) item.close(); });
        this.closePanel(false);
        this.openDialog(dialog, opener);
      }, o));
      this.dialogs.forEach(dialog => {
        dialog.querySelectorAll('[data-o-close]').forEach(button => button.addEventListener('click', () => this.closeDialog(dialog), o));
        dialog.addEventListener('cancel', event => { event.preventDefault(); this.closeDialog(dialog); }, o);
        dialog.addEventListener('click', event => {
          if (event.target === dialog) {
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeDialog(dialog);
            return;
          }
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const link = event.target.closest('a[href]');
          if (link && link.target !== '_blank') { dialog.close(); return; }
          if (event.target.closest('[data-o-sel-open]')) dialog.close();
        }, o);
        dialog.addEventListener('close', () => {
          dialog.classList.remove('is-closing');
          this.restorePage();
        }, o);
      });
      window.addEventListener('pageshow', () => {
        this.dialogs.forEach(dialog => { if (dialog.open) dialog.close(); });
        this.restorePage();
      }, o);
    }
    openDialog(dialog, opener) {
      this.returnFocus = opener;
      this.savedScroll = window.scrollY;
      this.savedBody = {};
      ['overflow', 'paddingRight', 'position', 'top', 'width', 'boxSizing'].forEach(property => { this.savedBody[property] = document.body.style[property]; });
      const scrollbar = window.innerWidth - document.documentElement.clientWidth;
      if (scrollbar > 0) document.body.style.paddingRight = (parseFloat(getComputedStyle(document.body).paddingRight) + scrollbar) + 'px';
      Object.assign(document.body.style, { overflow: 'hidden', position: 'fixed', top: -this.savedScroll + 'px', width: '100%', boxSizing: 'border-box' });
      this.pageLocked = true;
      dialog.classList.remove('is-closing');
      dialog.showModal();
      if (dialog.dataset.oDialog === 'drawer') {
        this.go('root', true);
        dialog.querySelectorAll('.o-nav__family[data-o-thumb]').forEach(button => {
          if (!button.querySelector('img')) this.feed(button.dataset.oThumb);
        });
        this.querySelector('[data-o-view="root"]')?.focus({ preventScroll: true });
      }
      dialog.scrollTop = 0;
      this.openers.forEach(button => button.setAttribute('aria-expanded', String(button.dataset.oOpen === opener.dataset.oOpen)));
    }
    closeDialog(dialog) {
      if (!dialog.open || dialog.classList.contains('is-closing')) return;
      if (this.reduce.matches) { dialog.close(); return; }
      dialog.classList.add('is-closing');
      clearTimeout(this.dialogTimer);
      this.dialogTimer = setTimeout(() => dialog.close(), dialog.dataset.oDialog === 'drawer' ? 210 : 160);
    }
    restorePage() {
      if (!this.pageLocked) return;
      this.pageLocked = false;
      Object.entries(this.savedBody).forEach(([property, value]) => { document.body.style[property] = value; });
      window.scrollTo({ top: this.savedScroll, behavior: 'instant' });
      this.openers.forEach(button => button.setAttribute('aria-expanded', 'false'));
      if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
    }

    /* Side menu levels */
    setupDrawer(o) {
      this.drawer = this.querySelector('[data-o-dialog="drawer"]');
      if (!this.drawer) return;
      this.views = [...this.drawer.querySelectorAll('[data-o-view]')];
      this.drawer.querySelectorAll('[data-o-go]').forEach(button => button.addEventListener('click', () => this.go(button.dataset.oGo), o));
      this.drawer.addEventListener('keydown', event => {
        if (event.key === 'Backspace' && this.currentView && this.currentView !== 'root' && !event.target.matches('input')) { event.preventDefault(); this.go('root'); }
      }, o);
    }
    go(name, instant) {
      const target = this.views?.find(view => view.dataset.oView === name);
      if (!target) return;
      const previous = this.currentView;
      if (instant) this.drawer.classList.add('is-instant');
      this.views.forEach(view => {
        const on = view === target;
        view.classList.toggle('is-current', on);
        view.inert = !on;
      });
      this.currentView = name;
      if (instant) requestAnimationFrame(() => requestAnimationFrame(() => this.drawer.classList.remove('is-instant')));
      if (name === 'root') {
        if (!instant && previous && previous !== 'root') this.drawer.querySelector('[data-o-go="' + previous + '"]')?.focus({ preventScroll: true });
        return;
      }
      target.scrollTop = 0;
      target.querySelector('.o-nav__v-title')?.focus({ preventScroll: true });
      this.fillView(target);
    }
    fillView(view) {
      const rail = view.querySelector('[data-o-m-rail]');
      const track = rail?.querySelector('[data-o-track]');
      if (track && !track.dataset.loaded) {
        track.dataset.loaded = 'true';
        track.innerHTML = this.skeleton(3);
        this.feed(rail.dataset.oUrl, true).then(data => {
          if (data && data.html) { track.innerHTML = data.html; this.updateRail(track); }
          else { rail.hidden = true; delete track.dataset.loaded; }
        });
      }
      view.querySelectorAll('[data-o-thumb]').forEach(link => {
        if (!link.querySelector('.o-nav__m-thumb img')) this.feed(link.dataset.oThumb);
      });
    }

    /* Cart and selection counters: hidden at 0, small bump when they change */
    setupBadges() {
      const sync = (node, bump) => {
        const value = node.textContent.trim();
        node.toggleAttribute('data-empty', value === '' || value === '0');
        if (bump && !this.reduce.matches) {
          node.classList.remove('is-bumped');
          void node.offsetWidth;
          node.classList.add('is-bumped');
        }
      };
      const badges = [...this.querySelectorAll('[data-o-badge]')];
      badges.forEach(node => sync(node, false));
      this.badgeObserver = new MutationObserver(records => {
        const changed = new Set();
        records.forEach(record => {
          const node = record.target.nodeType === 3 ? record.target.parentElement : record.target;
          const badge = node?.closest?.('[data-o-badge]');
          if (badge) changed.add(badge);
        });
        changed.forEach(node => sync(node, true));
      });
      badges.forEach(node => this.badgeObserver.observe(node, { childList: true, characterData: true, subtree: true }));
    }

    /* Notice strip: one message at a time, paused on hover or focus */
    setupNotice(o) {
      const root = this.querySelector('[data-o-notice]');
      const items = root ? [...root.querySelectorAll('[data-o-notice-item]')] : [];
      if (items.length < 2) return;
      let index = 0;
      let paused = false;
      const show = next => {
        items.forEach((item, position) => {
          const on = position === next;
          item.classList.toggle('is-active', on);
          if (on) item.removeAttribute('aria-hidden'); else item.setAttribute('aria-hidden', 'true');
          item.querySelectorAll('a').forEach(link => { if (on) link.removeAttribute('tabindex'); else link.tabIndex = -1; });
        });
        index = next;
      };
      this.noticeTimer = setInterval(() => {
        if (!paused && !document.hidden && !this.reduce.matches) show((index + 1) % items.length);
      }, 5200);
      root.addEventListener('pointerenter', () => { paused = true; }, o);
      root.addEventListener('pointerleave', () => { paused = false; }, o);
      root.addEventListener('focusin', () => { paused = true; }, o);
      root.addEventListener('focusout', () => { paused = false; }, o);
      document.addEventListener('shopify:block:select', event => {
        const position = items.indexOf(event.target.closest('[data-o-notice-item]'));
        if (position >= 0) { paused = true; show(position); }
      }, o);
    }

    setupScroll(o) {
      const update = () => {
        this.scrollFrame = null;
        if (this.pageLocked) return;
        const y = window.scrollY;
        this.classList.toggle('is-scrolled', y > 40);
        this.classList.toggle('is-compact', y > 160);
      };
      window.addEventListener('scroll', () => { if (!this.scrollFrame) this.scrollFrame = requestAnimationFrame(update); }, { passive: true, ...o });
      update();
    }

    disconnectedCallback() {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      clearTimeout(this.catTimer);
      clearTimeout(this.dialogTimer);
      clearInterval(this.noticeTimer);
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      this.badgeObserver?.disconnect();
      this.dialogs?.forEach(dialog => { if (dialog.open) dialog.close(); });
      this.restorePage();
      this.ac?.abort();
      this.ac = null;
    }
  });
}

/* v18: live search suggestions in the header search panel (Shopify predictive search). */
(() => {
  const root = document.querySelector('[data-o-hs]');
  if (!root || root.dataset.bound) return;
  root.dataset.bound = 'true';
  const input = root.querySelector('[data-o-hs-input]');
  const clear = root.querySelector('[data-o-hs-clear]');
  const results = root.querySelector('[data-o-hs-results]');
  const help = root.querySelector('[data-o-hs-default]');
  const list = root.querySelector('[data-o-hs-products]');
  const count = root.querySelector('[data-o-hs-count]');
  const all = root.querySelector('[data-o-hs-all]');
  const none = root.querySelector('[data-o-hs-none]');
  const colsWrap = root.querySelector('[data-o-hs-collections]');
  const colsList = root.querySelector('[data-o-hs-collection-list]');
  const ask = root.querySelector('[data-o-hs-ask]');
  let timer; let controller;
  const esc = (t) => String(t || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const priceLabel = (p) => {
    const tags = Array.isArray(p.tags) ? p.tags : [];
    const value = Number(p.price);
    if (tags.includes('order:checkout') && tags.includes('price-mode:fixed') && value > 0) return 'S$' + value.toLocaleString('en-SG', { maximumFractionDigits: 0 });
    return 'Price on request';
  };
  const reset = () => { results.hidden = true; help.hidden = false; list.replaceChildren(); };
  const searchUrl = (q) => '/search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
  const run = async (q) => {
    controller?.abort();
    controller = new AbortController();
    try {
      const url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.sku,tag';
      const res = await fetch(url, { signal: controller.signal, headers: { accept: 'application/json' } });
      const data = await res.json();
      const products = data?.resources?.results?.products || [];
      const collections = (data?.resources?.results?.collections || []).filter((c) => c.handle !== 'frontpage');
      list.innerHTML = products.map((p) => {
        const img = p.image ? `<img src="${esc(p.image)}${String(p.image).includes('?') ? '&' : '?'}width=160" alt="" width="64" height="64" loading="lazy">` : '<i></i>';
        return `<li><a href="${esc(new URL(p.url, location.origin).pathname)}">${img}<span><strong>${esc(p.title)}</strong><small>${esc([p.type, priceLabel(p)].filter(Boolean).join(' · '))}</small></span></a></li>`;
      }).join('');
      colsList.innerHTML = collections.map((c) => `<li><a href="${esc(new URL(c.url, location.origin).pathname)}">${esc(c.title)}</a></li>`).join('');
      colsWrap.hidden = !collections.length;
      count.textContent = products.length ? 'Pieces' : 'No piece found';
      all.href = searchUrl(q);
      all.hidden = !products.length;
      none.hidden = products.length > 0;
      if (!products.length) none.innerHTML = 'Nothing matches “' + esc(q) + '” yet. Try a stone (marble, travertine), a piece (coffee table) or a reference, or <a href="/pages/contact?request=question&message=' + encodeURIComponent('I am looking for: ' + q) + '">ask our team</a>.';
      help.hidden = true;
      results.hidden = false;
    } catch (e) { if (e.name !== 'AbortError') reset(); }
  };
  input.addEventListener('input', () => {
    const q = input.value.trim();
    clear.hidden = !q;
    clearTimeout(timer);
    if (q.length < 2) { reset(); return; }
    timer = setTimeout(() => run(q), 220);
  });
  clear.addEventListener('click', () => { input.value = ''; clear.hidden = true; reset(); input.focus(); });
  if (document.querySelector('[data-o-ai]')) {
    ask.hidden = false;
    ask.addEventListener('click', () => {
      root.closest('dialog')?.close();
      const q = input.value.trim();
      if (window.OmbrailAI) { if (q.length > 2) window.OmbrailAI.ask('Help me find: ' + q); else window.OmbrailAI.open(); }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ombrail-home-hero"]) return;
  try {
    
(() => {
  const players = new Map();
  function connect(scope = document) {
    scope.querySelectorAll('[data-oh-film-root]').forEach(root => {
      if (players.has(root)) return;
      const video = root.querySelector('video');
      const button = root.querySelector('[data-film-toggle]');
      const label = root.querySelector('[data-film-label]');
      const progress = root.querySelector('[data-film-progress]');
      if (!video || !button || !label) return;
      const desktop = matchMedia('(min-width:761px)');
      const reduced = matchMedia('(prefers-reduced-motion:reduce)');
      const controller = new AbortController();
      const options = { signal: controller.signal };
      let visible = false;
      let userPaused = false;
      let userStarted = false;
      let finished = false;
      let failed = false;
      let pendingPlay = false;
      let activeSource = null;
      let generation = 0;
      video.muted = true;
      video.defaultMuted = true;
      function paint() {
        const state = finished ? 'replay' : video.paused ? 'play' : 'pause';
        button.dataset.state = state;
        label.textContent = button.dataset['label' + state[0].toUpperCase() + state.slice(1)];
        if (progress) progress.style.transform = 'scaleX(' + (video.duration ? Math.min(1, video.currentTime / video.duration) : 0) + ')';
      }
      function source() {
        return desktop.matches ? video.dataset.filmSrc : video.dataset.filmMobileSrc;
      }
      function selectSource() {
        const next = source() || '';
        if (next === activeSource) return;
        activeSource = next;
        generation++;
        video.pause();
        video.removeAttribute('src');
        video.load();
        delete root.dataset.filmReady;
        finished = false;
        failed = false;
        pendingPlay = false;
      }
      function start() {
        if (pendingPlay || failed || !activeSource) return;
        if (!video.getAttribute('src')) video.src = activeSource;
        const playbackGeneration = generation;
        pendingPlay = true;
        video.play().catch(error => {
          if (playbackGeneration === generation && error.name !== 'AbortError') userPaused = true;
        }).finally(() => { if (playbackGeneration === generation) { pendingPlay = false; paint(); } });
      }
      function reconcile() {
        selectSource();
        button.hidden = !activeSource || failed;
        if (!activeSource || !visible || document.hidden) {
          video.pause();
          paint();
          return;
        }
        const automatic = !reduced.matches && !navigator.connection?.saveData;
        if (!userPaused && !finished && (automatic || userStarted)) start();
        else if (!automatic && !userStarted) video.pause();
        paint();
      }
      button.addEventListener('click', () => {
        if (!video.paused && !finished) {
          userPaused = true;
          video.pause();
        } else {
          userStarted = true;
          userPaused = false;
          if (finished || video.ended) video.currentTime = 0;
          finished = false;
          start();
        }
        paint();
      }, options);
      video.addEventListener('loadeddata', () => { root.dataset.filmReady = ''; }, options);
      video.addEventListener('play', paint, options);
      video.addEventListener('pause', paint, options);
      video.addEventListener('timeupdate', paint, options);
      video.addEventListener('ended', () => { finished = true; paint(); }, options);
      video.addEventListener('error', () => {
        failed = true;
        delete root.dataset.filmReady;
        button.hidden = true;
      }, options);
      desktop.addEventListener('change', reconcile, options);
      reduced.addEventListener('change', () => { userStarted = false; reconcile(); }, options);
      document.addEventListener('visibilitychange', reconcile, options);
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting && entries[0].intersectionRatio > .1;
        reconcile();
      }, { threshold: [0, .1], rootMargin: '-100px 0px 0px 0px' });
      observer.observe(root);
      players.set(root, () => {
        observer.disconnect();
        controller.abort();
        video.pause();
        video.removeAttribute('src');
        video.load();
        players.delete(root);
      });
      reconcile();
    });
  }
  // v29 (performance): the film starts once the poster (the largest image of the page) is on screen,
  // so the video download no longer competes with it. Fallback after 3 s.
  const poster = document.querySelector('[data-oh-film-root] .oh-hero__image img');
  let booted = false;
  const boot = () => { if (booted) return; booted = true; requestAnimationFrame(() => connect()); };
  if (!poster || (poster.complete && poster.naturalWidth)) boot();
  else {
    poster.addEventListener('load', boot, { once: true });
    poster.addEventListener('error', boot, { once: true });
    setTimeout(boot, 3000);
  }
  document.addEventListener('shopify:section:load', event => connect(event.target));
  document.addEventListener('shopify:section:unload', event => {
    players.forEach((dispose, root) => { if (event.target.contains(root)) dispose(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ombrail-product"]) return;
  try {
    
(function(){
  function bindProduct(scope){
    scope.querySelectorAll('[data-o-product]').forEach(function(root){
      if(root.dataset.oBound)return;
      root.dataset.oBound='true';
      var dataNode=root.querySelector('[data-o-product-data]');
      var product;
      try{product=JSON.parse(dataNode.value||dataNode.textContent);}catch(e){return;}
      var dialog=root.querySelector('[data-o-quote-dialog]');
      var sticky=root.querySelector('[data-o-sticky]');
      var mainAction=root.querySelector('[data-o-primary-action]');
      var mobileSummary=root.querySelector('[data-o-mobile-summary]');
      var actionEnd=root.querySelector('[data-o-action-end]');
      var quantity=root.querySelector('[data-o-quantity]');
      var purchaseQuantity=root.querySelector('[data-o-purchase-quantity]');
      var quoteQuantity=root.querySelector('[data-o-quote-quantity]');
      var buy=root.querySelector('[data-o-purchase] button[type="submit"]');
      var stickyBuy=root.querySelector('[data-o-sticky-buy]');
      var opener;
      function syncQuantity(){
        if(!quantity)return;
        var valid=quantity.checkValidity();
        if(purchaseQuantity)purchaseQuantity.value=quantity.value;
        if(quoteQuantity&&valid)quoteQuantity.value=quantity.value;
        if(buy)buy.disabled=!valid;
        if(stickyBuy)stickyBuy.disabled=!valid;
      }
      if(quantity){quantity.addEventListener('input',syncQuantity);quantity.addEventListener('change',syncQuantity);syncQuantity();}
      root.querySelectorAll('[data-o-qty-step]').forEach(function(step){
        step.addEventListener('click',function(){
          if(!quantity)return;
          var min=Number(quantity.min)||1;
          var next=Math.max(min,(Number(quantity.value)||min)+Number(step.dataset.oQtyStep));
          quantity.value=next;syncQuantity();
        });
      });
      root.querySelectorAll('[data-o-show-drawing]').forEach(function(link){
        link.addEventListener('click',function(event){
          var gallery=root.querySelector('[data-o-gallery]');
          if(!gallery||!gallery.querySelector('[data-o-drawing]'))return;
          event.preventDefault();
          gallery.dispatchEvent(new CustomEvent('ombrail:show-drawing'));
          var box=gallery.getBoundingClientRect();
          if(box.top<70||box.top>window.innerHeight*0.5)window.scrollTo({top:box.top+window.scrollY-84,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
        });
      });
      function updateSticky(){
        if(!sticky||!mainAction)return;
        var miniCart=document.querySelector('[data-o-mini-cart][open]');
        if((dialog&&dialog.open)||miniCart){sticky.hidden=true;return;}
        var show;
        if(window.matchMedia('(max-width: 850px)').matches&&mobileSummary){
          var summary=mobileSummary.getBoundingClientRect();
          var action=mainAction.getBoundingClientRect();
          show=summary.bottom<0&&!(action.top<window.innerHeight&&action.bottom>0);
        }else{
          show=actionEnd&&actionEnd.getBoundingClientRect().top<=0;
        }
        sticky.hidden=!show;
      }
      var pending=false;
      function scheduleSticky(){if(pending)return;pending=true;requestAnimationFrame(function(){pending=false;updateSticky();});}
      window.addEventListener('scroll',scheduleSticky,{passive:true});
      window.addEventListener('resize',scheduleSticky);
      updateSticky();
      document.addEventListener('shopify:section:unload',function(event){if(event.target.contains(root)){window.removeEventListener('scroll',scheduleSticky);window.removeEventListener('resize',scheduleSticky);}});
      var variantPicker=root.querySelector('[data-o-variant-select]');
      if(variantPicker)variantPicker.addEventListener('change',function(){
        var url=new URL(product.url,location.origin);
        url.searchParams.set('variant',variantPicker.value);
        var preview=new URLSearchParams(location.search).get('preview_theme_id');
        if(preview)url.searchParams.set('preview_theme_id',preview);
        location.assign(url.href);
      });
      function openQuote(mode,message,source){
        if(!dialog||typeof dialog.showModal!=='function')return false;
        opener=source||null;
        mode=mode||'standard';
        var request=dialog.querySelector('[data-o-quote-request]');
        if(request)request.value=mode==='custom'?'Custom configuration':mode==='question'?'Product question':mode==='room'?'Room preview - notify me':'Standard configuration';
        var copy={standard:['Request a quote.','Free and without obligation. You receive the price, stone and delivery by email, and nothing is made before you approve.','Anything we should know? (optional)','Access, timing, finish…'],custom:['Another size or stone.','Tell us what you have in mind. We check feasibility and reply with a price by email.','Size, stone or finish you have in mind','e.g. a different length, stone or finish'],question:['Ask our team.','We reply by email.','Your question','Your question about this piece'],room:['Room preview.','We will email you when the room view opens for this piece.','Anything to add? (optional)','The room or spot you have in mind…']}[mode]||null;
        if(copy){var t=dialog.querySelector('[data-o-quote-title]'),l=dialog.querySelector('[data-o-quote-lead]'),ml=dialog.querySelector('[data-o-quote-message-label]'),m=dialog.querySelector('[data-o-quote-message]'),lg=dialog.querySelector('[data-o-quote-logistics]');if(t)t.textContent=copy[0];if(l)l.textContent=copy[1];if(ml)ml.textContent=copy[2];if(m){m.placeholder=copy[3];m.required=mode==='custom'||mode==='question';if(typeof message==='string'&&message)m.value=message;}if(lg)lg.hidden=mode==='question'||mode==='room';}
        if(quoteQuantity&&quantity&&quantity.checkValidity())quoteQuantity.value=quantity.value;
        if(!dialog.open)dialog.showModal();
        var email=dialog.querySelector('input[type="email"]');
        if(email)email.focus();
        updateSticky();
        return true;
      }
      window.OmbrailOpenQuote=openQuote;
      root.querySelectorAll('[data-o-open-quote]').forEach(function(trigger){
        trigger.addEventListener('click',function(event){
          if(openQuote(trigger.dataset.oQuoteMode,'',trigger))event.preventDefault();
        });
      });
      if(dialog){
        var close=dialog.querySelector('[data-o-close-quote]');
        if(close)close.addEventListener('click',function(){dialog.close();});
        dialog.addEventListener('click',function(event){if(event.target===dialog)dialog.close();});
        dialog.addEventListener('close',function(){if(opener&&opener.isConnected)opener.focus({preventScroll:true});updateSticky();});
        if(dialog.querySelector('[data-o-quote-result]')){dialog.showModal();updateSticky();}
      }
      root.querySelectorAll('[data-o-ask]').forEach(function(link){
        link.addEventListener('click',function(event){
          var trigger=document.querySelector('[data-o-assistant-open]');
          if(!trigger)return;
          event.preventDefault();event.stopPropagation();
          var panel=document.querySelector('[data-o-assistant-panel]');
          if(panel&&!panel.hidden)return;
          trigger.click();
        });
      });
      var clamp=root.querySelector('[data-o-clamp]'),clampToggle=root.querySelector('[data-o-clamp-toggle]');
      if(clamp&&clampToggle){
        clamp.classList.add('is-clamped');
        if(clamp.scrollHeight>clamp.clientHeight+40){clampToggle.hidden=false;}else{clamp.classList.remove('is-clamped');}
        clampToggle.addEventListener('click',function(){var open=clamp.classList.toggle('is-clamped')===false;clampToggle.setAttribute('aria-expanded',String(open));clampToggle.textContent=open?'Show less':'Read more';});
      }
      var favorite=root.querySelector('[data-o-save-piece]');
      function syncFavorite(){if(!favorite)return;var exists=(window.OmbrailSelection?.getItems()||[]).some(function(item){return item.reference===product.reference;});favorite.setAttribute('aria-pressed',String(exists));}
      if(favorite)favorite.addEventListener('click',function(){var exists=(window.OmbrailSelection?.getItems()||[]).some(function(item){return item.reference===product.reference;});if(exists)window.OmbrailSelection.remove(product.reference);else document.dispatchEvent(new CustomEvent('ombrail:add-selection',{detail:Object.assign({},product,{quantity:product.moq,configuration:'standard',notes:'',stay:true}),bubbles:true}));syncFavorite();});
      document.addEventListener('ombrail:selection-change',syncFavorite);
      syncFavorite();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){bindProduct(document);});else bindProduct(document);
  document.addEventListener('shopify:section:load',function(event){bindProduct(event.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ombrail-projects"] && !Shopify.designMode) return;
  try {
    

(() => {
  function connectProjects() {
    document.querySelectorAll('[data-o-projects]').forEach(root => {
      if (root.dataset.oProjectsConnected) return;
      root.dataset.oProjectsConnected = 'true';
      const form = root.querySelector('.o-projects-form');
      const steps = [...root.querySelectorAll('[data-o-project-step]')];
      if (!form || !steps.length) return;
      const progress = root.querySelector('[data-o-project-progress]');
      const back = root.querySelector('[data-o-project-back]');
      const next = root.querySelector('[data-o-project-next]');
      const send = root.querySelector('[data-o-project-send]');
      const labels = [...root.querySelectorAll('[data-o-project-step-label]')];
      let current = 0;
      function show(index, focus = true) {
        current = index;
        steps.forEach((step, i) => { step.hidden = i !== current; });
        labels.forEach((label, i) => { if (i === current) label.setAttribute('aria-current', 'step'); else label.removeAttribute('aria-current'); });
        back.hidden = current === 0;
        next.hidden = current === steps.length - 1;
        send.hidden = current !== steps.length - 1;
        if (focus) steps[current].querySelector('legend').focus({ preventScroll: true });
      }
      function invalid(step) { return [...step.querySelectorAll('input,textarea,select')].find(field => !field.checkValidity()); }
      next.addEventListener('click', () => { const field = invalid(steps[current]); if (field) { field.reportValidity(); return; } show(current + 1); });
      back.addEventListener('click', () => show(Math.max(0, current - 1)));
      form.addEventListener('submit', event => {
        if (current < steps.length - 1) { event.preventDefault(); next.click(); return; }
        for (let i = 0; i < steps.length; i++) { const field = invalid(steps[i]); if (field) { event.preventDefault(); show(i); field.reportValidity(); return; } }
      });
      root.querySelectorAll('[data-o-project-room]').forEach(link => {
        link.addEventListener('click', () => {
          const radio = root.querySelector(`[data-o-room-value="${link.dataset.oProjectRoom}"]`);
          if (radio) radio.checked = true;
          show(0, false);
        });
      });
      progress.hidden = false;
      form.noValidate = true;
      show(0, false);
    });
  }
  document.addEventListener('shopify:section:load', connectProjects);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connectProjects, { once: true }); else connectProjects();
})();


  } catch(e) { console.error(e); }
})();
})();
